import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";

export class TwoOptionsPanel extends VerticalStandardPanel {

    private onAcceptCallback: (() => unknown) | undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, title: string, subtitle: string,
                atlasKey: string | undefined, iconKey: string, blockFirstText: string, blockSecondText: string,
                onAcceptCallback: () => unknown, okText: string, fontSizeDelta: number = 0, iconShiftX: number = 0, iconShiftY: number = 0,
                closeName: string = Tr('zakrit'), onCloseCallback: (() => unknown) | undefined = undefined) {
        super(scene, canvas, title);

        this.onAcceptCallback = onAcceptCallback;

        let nameText = TextUtils.addTextByFamily(scene, subtitle, 0, -170,
            '#ffd465', 18 + fontSizeDelta, 'bold', 450, Fonts.MYRIADPRO_REGULAR);

        let light = SpriteUtils.addSprite(this.scene, -135, -90, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT);
        let icon = atlasKey ? SpriteUtils.addSprite(this.scene, -150 + iconShiftX, -120 + iconShiftY, atlasKey, iconKey)
            : SpriteUtils.addSprite(this.scene, -150 + iconShiftX, -120 + iconShiftY, iconKey);

        let blockFirst = TextUtils.addTextAdvanced(scene, blockFirstText, 55, -90,
            '#a2ff82', 15 + fontSizeDelta, 'normal', 280, 'center', 2, Fonts.ARIAL_MT);

        this.add([nameText, light, icon, blockFirst]);

        let blockSecond = TextUtils.addTextByFamily(scene, blockSecondText,
            0, blockFirst.y + 110, '#FFD465', 15 + fontSizeDelta, 'normal', 450, Fonts.ARIAL_MT);
        this.add(blockSecond);

        this.addCustomButton(-100, 150, closeName, Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, () => {
            if (onCloseCallback) {
                onCloseCallback();
            }
        });
        this.addCustomButton(100, 150, okText, Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, onAcceptCallback);
    }

    protected onClose(): void {

    }

}
